'use client';

import { useTranslations } from 'next-intl';
import { HeaderStoreLocationButton } from 'components/pcc-components';
import { useStoreInfoDrawer } from '../../store-info-drawer-context';
import { useAssociatedDealer } from 'components/associated-dealers/associated-dealer-context';

export const StoreAccountButton = () => {
  const t = useTranslations();
  const storeInfoDrawer = useStoreInfoDrawer();
  const { associatedDealerDrawer } = useAssociatedDealer();

  const changeAccountLabel = t('CHANGE_ADP_CSP_CUST');

  return (
    <HeaderStoreLocationButton
      label={changeAccountLabel}
      onClick={() => {
        storeInfoDrawer.closeDrawer();
        associatedDealerDrawer.openDrawer();
      }}
    />
  );
};
